import React from "react";
import "./StepperCompromiso.css";

const pasos = [
    {
        numero: 1,
        titulo: "Información solicitante"
    },
    {
        numero: 2,
        titulo: "Líneas del negocio"
    },
    {
        numero: 3,
        titulo: "Datos del negocio"
    },
    {
        numero: 4,
        titulo: "Información del compromiso"
    }
];

const StepperCompromiso = ({ activeStep }) => {
    return (
        <div className="stepper-compromiso">

            {pasos.map((paso, index) => {

                const estaActivoOCompletado =
                    paso.numero <= activeStep;

                return (
                    <React.Fragment key={paso.numero}>

                        <div
                            className={
                                "stepper-item " +
                                (estaActivoOCompletado
                                    ? "activo"
                                    : "inactivo")
                            }
                        >
                            <div className="stepper-numero">
                                {paso.numero}
                            </div>

                            <div className="stepper-titulo">
                                {paso.titulo}
                            </div>
                        </div>

                        {index < pasos.length - 1 && (
                            <div
                                className={
                                    "stepper-linea " +
                                    (paso.numero < activeStep
                                        ? "completada"
                                        : "inactiva")
                                }
                            />
                        )}

                    </React.Fragment>
                );
            })}

        </div>
    );
};

export default StepperCompromiso;